<template>
  <div class="page-container">
    <page-menu></page-menu>
    <div id="page-wrapper">
      <page-header></page-header>
      <router-view :key="$route.fullPath"></router-view>
      <page-footer></page-footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useHead } from '@unhead/vue';

import PageHeader from './components/PageHeader.vue';
import PageMenu from './components/PageMenu.vue';
import PageFooter from './components/PageFooter.vue';

useHead({
  htmlAttrs: {
    lang: 'it',
  },
  titleTemplate: (title) => {
    return (title ? title + ' | ' : '') + import.meta.env.VITE_TITLE_SHORT;
  },
  meta: [
    { name: 'description', content: import.meta.env.VITE_DESCRIPTION },
    { name: 'keywords', content: import.meta.env.VITE_KEYWORDS },
    { name: 'copyright', content: import.meta.env.VITE_BUSINESS_NAME },
  ],
  // script: [
  //   {
  //     type: 'application/ld+json',
  //     innerHTML: JSON.stringify({
  //       '@context': 'https://schema.org',
  //       '@type': 'SportsTeam',
  //       name: 'Atletico Porchia',
  //       legalName: 'A.S.D. Atletico Porchia',
  //       vatID: 'IT02098300441',
  //       address: {
  //         '@type': 'PostalAddress',
  //         streetAddress: 'Via XXIV Maggio 46',
  //         postalCode: '63068',
  //         addressLocality: 'Montalto delle Marche',
  //         addressRegion: 'AP',
  //         addressCountry: 'IT',
  //       },
  //       image: {
  //         '@type': 'ImageObject',
  //         contentUrl: '/images/logo.svg',
  //       },
  //       sport: 'https://www.wikidata.org/wiki/Q2736',
  //       coach: {
  //         '@type': 'Person',
  //         name: 'Michele Stoppo',
  //       },
  //       member: [
  //         {
  //           '@type': 'OrganizationRole',
  //           member: [{ '@type': 'Person', name: 'Jacopo Pettirossi' }],
  //           roleName: 'Portiere',
  //         },
  //         {
  //           '@type': 'OrganizationRole',
  //           member: [{ '@type': 'Person', name: 'Alessio Pacetti' }],
  //           roleName: 'Portiere',
  //         },
  //       ],
  //     }),
  //   },
  // ],
});

onMounted(() => {
  window.setTimeout(() => {
    document.body.classList.remove('is-preload');
  }, 100);
});
</script>

<style lang="scss">
@use './assets/sass/main.scss';
</style>
